// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"f3468c79","86":"fe7f7a67","94":"ff57bbee","124":"58a462b8","185":"a9225691","257":"985015d3","297":"8bf0232f","340":"073f9d4a","397":"5e8e8d6e","445":"0e66f5c9","673":"95ea0fc6","784":"90c666e3","874":"14084394","877":"da76ac7f","884":"f0a00b9f","913":"23530dd4"}[chunkId] + ".chunk.js";
};